import React, { Component } from "react";
import SuccessAlert from "./../../../SuccessAlert";
import AcceptShareModalService from "./AcceptShareModal.service";
import "./AcceptShareModal.scss";

export default class AcceptShareModal extends Component {
    state = {
        success: false,
        isLoadingAccept: false,
        isLoadingReject: false
    };

    acceptShare = () => {
        this.setState({
            isLoadingAccept: true
        });

        AcceptShareModalService.respondShare(
            this.props.id,
            true,
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(notification => {
                this.props.removeNotification(this.props.id, true);
                this.setState({
                    success: true
                });
                setTimeout(() => {
                    this.props.close();
                }, 2500);
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoadingAccept: false
                });
            });
    };

    rejectShare = () => {
        this.setState({
            isLoadingReject: true
        });

        AcceptShareModalService.respondShare(
            this.props.id,
            false,
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(notification => {
                this.props.removeNotification(this.props.id, false);
                this.setState({
                    success: true
                });
                setTimeout(() => {
                    this.props.close();
                }, 2500);
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
            })
            .finally(() => {
                this.setState({
                    isLoadingReject: false
                });
            });
    };

    render() {
        return (
            <div>
                {this.state.success ? (
                    <SuccessAlert message="Bookmarks accepted!" />
                ) : (
                    ""
                )}
                <div className="p-4">
                    <h1>Accept bookmarks</h1>
                    <div>
                        <b>
                            {this.props.notification.bookmark_share.user.name +
                                " " +
                                this.props.notification.bookmark_share.user
                                    .last_name}
                        </b>{" "}
                        (
                        <i>
                            @
                            {
                                this.props.notification.bookmark_share.user
                                    .username
                            }
                        </i>
                        ) wants to share some bookmarks with you. Do you accept
                        them?
                    </div>
                    <div className="d-flex justify-content-between m-1 mt-3">
                        <button
                            className="btn btn-danger custom-button"
                            onClick={this.rejectShare}
                            disabled={this.state.isLoadingReject}
                        >
                            {this.state.isLoadingReject ||
                            this.state.isLoadingAccept ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Reject"
                            )}
                        </button>
                        <button
                            className="btn btn-primary custom-button"
                            onClick={this.acceptShare}
                            disabled={
                                this.state.isLoadingReject ||
                                this.state.isLoadingAccept
                            }
                        >
                            {this.state.isLoadingAccept ? (
                                <div
                                    id="btn-login-spinner"
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Accept"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
